import { apiClient } from '@/shared/api/client'

export async function getSales(params = {}) {
  const response = await apiClient.get('/admin/sales', {
    params,
  })

  return response.data
}

export async function createSales(payload) {
  const response = await apiClient.post('/admin/sales', payload)

  return response.data
}

export async function deleteSales(id) {
  const response = await apiClient.delete(`/admin/sales/${id}`)

  return response.data
}

export async function updateSales(id, payload) {
  const response = await apiClient.put(`/admin/sales/${id}`, payload)
  return response.data
}

export async function assignSalesTarget(id, payload) {
  const response = await apiClient.put(`/admin/sales/${id}/target`, payload)
  return response.data
}

export async function getSalesTargetsAndAchievements(id, year) {
  const response = await apiClient.get(`/admin/sales/${id}/targets`, {
    params: { year },
  })
  return response.data
}
